import React from 'react'
import { Loader } from 'belle-js'
import styles from './LoadingComponent.module.scss'

const LoadingComponent = () => (
  <div className={styles.loadingContainer}>
    <Loader className={styles.loader} />
  </div>
)

export default LoadingComponent



// WEBPACK FOOTER //
// ./src/components/Client/LoadingComponent/LoadingComponent.jsx